import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MobileUser } from '../models/MobileUser';
import { NatLanguage } from '../models/nat-language';
import { ApiProvider } from '../providers/api.provider';
import { SectorService } from './sector.service';
import { TokenJwtService } from './tokenJwt.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<MobileUser>;
  public currentUser: Observable<MobileUser>;
  public focusBarcode: boolean;
  private localUserStorageName = 'currentUser';

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private apiProvider: ApiProvider,
    private tokenJwtService : TokenJwtService
  ) {
    this.focusBarcode = true;
    this.initialiseUser();

    if (this.currentUserValue != null) {
      if (this.currentUserValue.language) {
        this.translateService.use(
          this.currentUserValue.language === NatLanguage.En ? 'en' : 'fr'
        );
      } else {
        this.translateService.use(navigator.language.slice(0, 2) || 'fr');
      }
    }
  }
  public get currentUserValue(): MobileUser {
    return this.currentUserSubject.value;
  }

  init() {
    this.http.post<boolean>(environment.apiUrl, '', {});
  }

  initialiseUser() {
    this.currentUserSubject = new BehaviorSubject<MobileUser>(
      JSON.parse(localStorage.getItem(this.localUserStorageName))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  login(username, password) {
    this.init();

    const user = new MobileUser();
    user.Password = password;
    user.UserName = username;


    const response = this.http
      .post<any>(
        environment.apiUrl + 'api/v3/Mobiles/MobileGetMobileUser',
        user,
        {
          headers: new HttpHeaders().set(
            'Authorization',
            '*NationexInternalAPI*'
          ), params: { audience: "tpslRoute" }
        }
      )
      .pipe(
        map((response) => {
          // no sectorids defined in sector_ids, extract sector from routes_ids
          let User: MobileUser = response
          let token = response.token
          if (
            User.SectorIds.length === 0 &&
            User.RouteIds.length > 0
          ) {
            let SectorList: number[] = [];
            let SectorId: number = 0;
            // Check each route to extract distinct sector
            for (let allowedroute of User.RouteIds) {
              SectorId = Number(allowedroute.toString().substring(0, 3));
              // Add sector
              if (SectorList.indexOf(SectorId) === -1) {
                SectorList.push(SectorId);
              }
            }
            if (SectorList.length > 0) {
              User.SectorIds = SectorList;
            }
          }
          localStorage.setItem(
            this.localUserStorageName,
            JSON.stringify(User)
          );
          localStorage.setItem('jwtToken', token)
          this.tokenJwtService.startTokenCheck();
          this.currentUserSubject.next(User);
          /* MobileUser.AutoSendNCV = false;
          MobileUser.FilterCompleted = 0;*/
          return MobileUser;
        })
      );
    return response;
  }

  public setUser(user: any) {
    this.currentUserSubject.next(user);
  }

  public set updateAutoSendNCV(autoSendNCV: boolean) {
    this.currentUserSubject.value.AutoSendNCV = autoSendNCV;
    this.updateStorage(this.currentUserSubject.value);
  }
  public set updateChuteID(ChuteID: number) {
    this.currentUserSubject.value.ChuteID = ChuteID;
    this.updateStorage(this.currentUserSubject.value);
  }
  public set updateFilterCompleted(filterCompleted: number) {
    this.currentUserSubject.value.FilterCompleted = filterCompleted;
    this.updateStorage(this.currentUserSubject.value);
  }
  public set updateRouteID(RouteID: number) {
    this.currentUserSubject.value.RouteId = RouteID;
    this.updateStorage(this.currentUserSubject.value);
  }
  public set updateLanguage(Language: number) {
    this.currentUserSubject.value.language = Language;
    this.updateStorage(this.currentUserSubject.value);
  }
  updateStorage(mobileUser: MobileUser) {
    localStorage.setItem(this.localUserStorageName, JSON.stringify(mobileUser));
    this.initialiseUser();
  }
  logout() {
    let user = JSON.parse(localStorage.getItem("currentUser")); // Parse the stored JSON string into an object
    let username = user.UserName; // Access the UserName property
    localStorage.setItem("lastUserName", username)
    localStorage.removeItem(this.localUserStorageName);
    localStorage.removeItem('currentRoute');
    this.tokenJwtService.stopTokenCheck();
    this.currentUserSubject.next(null);
  }

}
